const getUserForm = (state) => {
    return state.user_form
}

export {
    getUserForm
};